import React__default from 'react';
import Pagination from 'reactstrap/lib/Pagination';
import PaginationItem from 'reactstrap/lib/PaginationItem';
import PaginationLink from 'reactstrap/lib/PaginationLink';
import { ReactComponent as SvgAngleRight } from '../../icons/AngleRight.svg.js';
import { ReactComponent as SvgAngleLeft } from '../../icons/AngleLeft.svg.js';

const AppPagination = ({ currentPage, pagesCount, handleClick, isMobile, isScroll, PrevLink, NextLink }) => {
    PrevLink = (PrevLink || ((props) => React__default.createElement("div", Object.assign({}, props))));
    NextLink = (NextLink || ((props) => React__default.createElement("div", Object.assign({}, props))));
    const onClickPrev = (e) => {
        if (!handleClick) {
            return;
        }
        e.preventDefault();
        if (isScroll) {
            handleClick(-100);
        }
        else {
            handleClick(currentPage - 1);
        }
    };
    const onClickNext = (e) => {
        if (!handleClick) {
            return;
        }
        e.preventDefault();
        if (isScroll) {
            handleClick(100);
        }
        else {
            handleClick(currentPage + 1);
        }
    };
    return (React__default.createElement("div", { style: { height: isMobile ? "26px" : "38px" } },
        React__default.createElement(Pagination, { "aria-label": "Page navigation example" },
            React__default.createElement(PaginationItem, { disabled: currentPage <= 1 && isScroll === undefined },
                React__default.createElement(PrevLink, null,
                    React__default.createElement(PaginationLink, { onClick: onClickPrev, previous: true, style: {
                            borderRadius: "50%",
                            borderColor: "#80868B",
                            height: isMobile ? "26px" : "38px",
                            width: isMobile ? "26px" : "38px",
                            opacity: 0.4,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "8px"
                        }, id: "Pagination_prev" },
                        React__default.createElement("span", { style: { display: "flex" } },
                            React__default.createElement(SvgAngleRight, { height: isMobile ? "8.12px" : "13.12px", width: isMobile ? "4.68px" : "7.55px" }))))),
            React__default.createElement(PaginationItem, { disabled: currentPage >= pagesCount && isScroll === undefined },
                React__default.createElement(NextLink, null,
                    React__default.createElement(PaginationLink, { next: true, onClick: onClickNext, 
                        // className={searchStyles.pagination_arrow}
                        style: {
                            borderRadius: "50%",
                            borderColor: "#80868B",
                            height: isMobile ? "26px" : "38px",
                            width: isMobile ? "26px" : "38px",
                            opacity: 0.4,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }, id: "Pagination_next" },
                        React__default.createElement("span", { style: { display: "flex" } },
                            React__default.createElement(SvgAngleLeft, { height: isMobile ? "8.12px" : "13.12px", width: isMobile ? "4.68px" : "7.55px" }))))))));
};

export { AppPagination as default };
//# sourceMappingURL=pagination.js.map
